import { DateTime } from "luxon";
import { parseDate } from "./date";

const createHolidaysHelper = (holidays = []) => {
    console.log({holidays})

    const isHoliday = (date) => {
        const parsedDate = DateTime.fromJSDate(parseDate(date));

        return holidays.some(holiday => {
            return DateTime.fromSQL(holiday.date).toFormat('yyyy-MM-dd') === parsedDate.toFormat('yyyy-MM-dd');
        });
    }

    return { isHoliday }
}

export default createHolidaysHelper;